import Drawer from 'components/drawer/Drawer';
import { bindMethod } from 'helpers/bind';
import { frameToMs } from 'helpers/easings';
import store from 'store';
import mqStore from 'store/mqStore';
class ProductInfos extends Drawer {
    constructor(el, options) {
        super(el, options);
        this.name = 'infos';
        this.params = {
            desktop: {
                axis: 'X',
                direction: 'reversed'
            },
            mobile: {
                axis: 'Y',
                direction: 'reversed'
            }
        };
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        super.bindEvents(add);
        window[method]('size-guide:open-mobile', this.onOpenSizeGuideMobile);
        window[method]('sizebay:rendered', this.refresh.bind(this));
        this.refs.infosToggle?.map(toggle => toggle[method]('click', this.onFindMySizeClick));
    }
    onOpenSizeGuideMobile = () => {
        if (this.refs?.['size-guide']?.[0]) {
            this.refs['size-guide'][0]?.scrollIntoView({ behavior: 'smooth' });
            this.refs['size-guide'][0].checked = true;
        }
    };
    onFindMySizeClick = (e) => {
        e.preventDefault();
    };
    onBeginToggle(value) {
        if (value) {
            const accordion = store.infosAccordion.get();
            const input = this.refs[accordion][0];
            input.checked = value;
        }
    }
    onEndToggle(value) {
        if (!value) {
            const input = this.el.querySelectorAll('input');
            input.forEach((input) => {
                input.checked = false;
            });
        }
    }
    onOpenInfosPanel = (isOpen) => {
        this.emit('open:info');
        const accordion = store.infosAccordion.get();
        if (accordion) {
            const input = this.refs[accordion][0];
            if (isOpen)
                input.checked = isOpen;
            setTimeout(() => {
                if (!isOpen) {
                    store.infosAccordion.set(null);
                    this.el.querySelectorAll('.accordion__checkbox').forEach((input) => { input.checked = false; });
                }
            }, frameToMs(50));
        }
    };
    toggle(value) {
        super.toggle(value);
    }
    resize() {
        super.resize();
        this.el.style.setProperty('--product-infos-right-height', `${this.refs.productInfosRight.clientHeight}px`);
        if (mqStore.tabletPortrait.get())
            this.refs.informations[0].checked = true;
    }
}
export default ProductInfos;
